<div [ngClass]="{'padding-fixed': fixed}">
    <app-section-one-bac [brand]="brand"></app-section-one-bac>
    <app-section-two-bac [brand]="brand"></app-section-two-bac>
    <app-section-three-bac [brand]="brand"></app-section-three-bac>
    <app-section-four-bac [brand]="brand"></app-section-four-bac>
    <app-footer-landing-bac [brand]="brand" class="landing-footer"></app-footer-landing-bac>
</div>